export default {"src":"/_next/static/media/youtube-icon.dc964e88.svg","height":512,"width":512};